// add-to-cart--custom.js - Додавання товару в корзину

// Утиліти
function hashString(str) {
    let h = 0, i = 0, len = str?.length || 0;
    while (i < len) {
        h = ((h << 5) - h + str.charCodeAt(i++)) & 0xffffffff;
    }
    return h.toString(36);
}

async function fetchCartJSON() {
    const res = await fetch('/cart.js', {credentials: 'same-origin', cache: 'no-store'});
    const data = await res.json();
    return {data, status: res.status, ok: res.ok};
}

async function fetchSectionsByIds(sectionIds) {
    const params = new URLSearchParams();
    params.set('sections', sectionIds.join(','));
    const url = `${(window.Shopify?.routes?.root) || '/'}?${params.toString()}`;
    const res = await fetch(url, {
        headers: {Accept: 'application/json'},
        credentials: 'same-origin',
        cache: 'no-store'
    });
    
    const raw = await res.text();
    const parsed = JSON.parse(raw);
    
    const doc = new DOMParser().parseFromString(raw, 'text/html');
    const map = {};
    for (const id of sectionIds) {
        const fresh = doc.querySelector(`[data-section-id="${id}"]`);
        if (fresh) map[id] = fresh.outerHTML;
    }
    
    return {ok: res.ok, status: res.status, format: 'json', map};
}

function replaceSectionsInDOM(sectionsMap) {
    const report = [];
    for (const [id, html] of Object.entries(sectionsMap)) {
        const current = document.querySelector(`[data-section-id="${id}"]`);
        if (current && html) {
            current.outerHTML = html;
            report.push({id, replaced: true});
        } else {
            report.push({id, replaced: false, reason: !current ? 'not found' : 'no html'});
        }
    }
    return report;
}

function attachDrawerObserver(drawerEl) {
    if (!drawerEl) return null;
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                console.log('Drawer content updated');
            }
        });
    });
    observer.observe(drawerEl, {childList: true, subtree: true});
    return observer;
}

// Основна функція додавання в корзину
async function addToCart(variantId, qty = 1, properties = {}) {
    let observer = null;
    let buttonElement = null;

    try {
        if (!variantId) throw new Error('variantId is required');

        // Знаходимо кнопку, яка викликала функцію
        buttonElement = event?.target || document.querySelector(`#add-to-cart-${variantId}`) || document.querySelector(`button[onclick*="${variantId}"]`);
        
        // Додаємо стан завантаження
        if (buttonElement && buttonElement instanceof HTMLButtonElement) {
            buttonElement.disabled = true;
            buttonElement.classList.add('loading');
            const originalText = buttonElement.textContent;
            buttonElement.dataset.originalText = originalText || '';
            buttonElement.textContent = 'Adding...';
        }

        let drawerEl = document.querySelector('cart-drawer-component');
        const drawerSectionId = drawerEl?.closest('[data-section-id]')?.getAttribute('data-section-id') || null;
        const bubbleSectionId = document.querySelector('[data-section-id*="cart-icon"],[data-section-id*="cart_bubble"],[data-section-id*="header-cart"]')
        ?.getAttribute('data-section-id') || null;
        const sectionIds = [drawerSectionId, bubbleSectionId].filter(Boolean);

        if (!drawerEl) console.warn('Не знайдено <cart-drawer-component> у DOM');
        if (!drawerSectionId) console.warn('Дровер НЕ всередині секції');

        observer = attachDrawerObserver(drawerEl);

        // 1) Додаємо товар в корзину
        const addPayload = {items: [{id: Number(variantId), quantity: Math.max(1, Number(qty) || 1), properties}]};
        const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify(addPayload),
            credentials: 'same-origin',
            cache: 'no-store'
        });
        const addText = await addRes.text();
        let addJson = null; 
        try {addJson = JSON.parse(addText);} catch {}
        
        if (!addRes.ok) {
            console.error('Cart add failed:', addJson?.description || addText);
            document.dispatchEvent(new CustomEvent('ThemeEvents:cartUpdate', {detail: {data: {didError: true, error: addJson?.description || addText}}, bubbles: true, composed: true}));
            throw new Error(addJson?.description || `HTTP ${addRes.status}`);
        }

        // 2) Оновлюємо секції
        if (sectionIds.length) {
            const sectionsResp = await fetchSectionsByIds(sectionIds);
            replaceSectionsInDOM(sectionsResp.map);
            
            // Оновлюємо глобальний cart
            try {
                const cartResponse = await fetch('/cart.js');
                if (cartResponse.ok) {
                    const cartData = await cartResponse.json();
                    
                    if (window.cart) {
                        Object.assign(window.cart, cartData);
                    }
                    
                    if (window.Shopify && window.Shopify.cart) {
                        Object.assign(window.Shopify.cart, cartData);
                    }
                    
                    window.cart = cartData;
                    
                    document.dispatchEvent(new CustomEvent('cart:updated', {
                        detail: {cart: cartData},
                        bubbles: true,
                        composed: true
                    }));
                }
            } catch (e) {
                console.error(e);
            }
        } else {
            console.warn('Секції для оновлення не знайдені');
        }

        // 3) Відкриваємо дравлер
        if (drawerEl && typeof drawerEl.open === 'function') {
            drawerEl.open();
        } else {
            document.querySelector('[data-cart-drawer-open]')?.click();
        }
    } catch (err) {
        console.error('addToCart error:', err);
        throw err;
    } finally {
        if (buttonElement && buttonElement instanceof HTMLButtonElement) {
            buttonElement.disabled = false;
            buttonElement.classList.remove('loading');
            const originalText = buttonElement.dataset.originalText;
            buttonElement.textContent = originalText;
            delete buttonElement.dataset.originalText;
        }
        observer?.disconnect();
    }
}

// Експорт
window.addToCart = addToCart;